import request from '../../../utils/request';

export type SettingSource = 'table' | 'environment' | 'default';

export interface ISnAiSetting {
  key: string;
  description: string;
  tableValue?: string;
  environmentValue?: string;
  defaultValue?: string;
  effectiveValue?: string;
  source: SettingSource;
  warning?: string;
}

const BASE = '/cmdb-sn-ai-settings';

class SnAiSettingsService {
  async list(): Promise<ISnAiSetting[]> {
    const res = await request({ url: BASE, method: 'GET' });
    return res.data.body.data;
  }

  /** Blank/null clears the saved value: the setting falls back to the environment variable, then the default. */
  async update(key: string, settingValue: string | null): Promise<ISnAiSetting> {
    const res = await request({ url: `${BASE}/${key}`, method: 'PUT', data: { setting_value: settingValue } });
    return res.data.body.data;
  }
}

export default new SnAiSettingsService();
